import { AutocompleteOption } from "components/Form/components/Autocomplete/Autocomplete";
import { actions as autocompleteActions } from "components/Form/components/Autocomplete/Autocomplete.reducer";
import autocompleteQuery from "components/Form/components/Autocomplete/Autocomplete.type";
import { Dispatch } from "redux";
import { getSearchField, SingleField } from "utils/utils";

export const getAutocompleteIri = ({ resourceName }: { resourceName?: string }) => resourceName;

export const fetchAutocomplete = ({
    dispatch,
    promise,
    options,
    inputValue,
    defaultValue,
    params,
    singleOptionQueryField,
    iri,
    search,
    additionalQueryParams = {},
}: {
    dispatch: Dispatch<any>;
    promise: {
        resolve: (value: unknown) => void;
        reject: (reason: any) => void;
    };
    options: any;
    inputValue?: string;
    defaultValue?: AutocompleteOption;
    params?: { offset: number; limit: number };
    singleOptionQueryField?: SingleField;
    iri: string;
    search?: boolean;
    additionalQueryParams?: Record<string, any>;
}) => {
    const { resource: resourceName, resourceBody = "", hasNameAsOptionValue, queryField } = options;
    const filter: { and: any[] } = {
        and: [],
    };
    if (inputValue) {
        const searchField = getSearchField({ term: inputValue });
        filter.and.push(searchField);
    }
    if (queryField) {
        filter.and.push(queryField);
    }

    if (singleOptionQueryField) {
        filter.and.push(singleOptionQueryField);
    }

    dispatch({
        type: autocompleteActions.START_FETCHING_AUTOCOMPLETE,
        promise: promise,
        resourceName,
        hasNameAsOptionValue,
        params: {
            query: autocompleteQuery(resourceName, resourceBody),
            variables: {
                // TODO use filter query builder https://app.clickup.com/t/861m5z724
                filter: JSON.stringify(filter),
                order: "+name",
                ...(params || {}),
            },
            ...additionalQueryParams,
        },
        overwritePrevValue: params?.offset === 0,
        defaultValue,
        iri,
        search,
    });
};

export const isInputValueIncluded = (item: AutocompleteOption, inputValue: string) => {
    const inputValueLower = inputValue.toLowerCase();
    return item?.label != null
        ? item.label.toLowerCase().includes(inputValueLower)
        : item?.value?.toLowerCase().includes(inputValueLower);
};
